import { Next, useNext as useLizardNext, usePageLoading } from '@wix/funnel-builder-lizard'

export const useNext = (): Next => {
  const next = useLizardNext()
  const [pageLoading] = usePageLoading()

  return (...args) => {
    if (pageLoading) {
      return
    }
    next(...args)
  }
}
